import { CustomMultiFilterButton } from "../button/CustomMultiFilterButton";
import Translate from "../../translate/Translate";

export default function TypeFilterButton({ currentValues, setValues, type, excludeValues = [] }) {
    let values;
    if (type === "userManagement") {
        values = [
            { label: Translate("common.allType"), value: "all" },
            { label: "LG Admin", value: "lgAdmin" },
            { label: "Franchise Admin", value: "franchiseAdmin" },
            { label: "Call Center", value: "callCenter" },
            { label: "Shop Owner", value: "shopOwner" },
        ];
    } else if (type === "marketing") {
        values = [
            { label: Translate("common.allType"), value: "all" },
            { label: Translate("marketing.type.discount"), value: "discount" },
            { label: Translate("marketing.type.free"), value: "free" },
        ];
    }

    if (excludeValues.length > 0) {
        values = values.filter((item) => !excludeValues.includes(item.value));
    }

    return (
        <CustomMultiFilterButton
            icon={currentValues.includes("all") ? "type_01" : "type_01_active"}
            currentValues={currentValues}
            setValues={setValues}
            values={values}
            multiText={"Type"}
            iconHeight={"14px"}
        />
    );
}
